import { render, staticRenderFns } from "./AddEventFaculty.vue?vue&type=template&id=6964fa6e"
import script from "./AddEventFaculty.vue?vue&type=script&lang=js"
export * from "./AddEventFaculty.vue?vue&type=script&lang=js"
import style0 from "./AddEventFaculty.vue?vue&type=style&index=0&id=6964fa6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports